import React from "react";

export const Button = ({ item, activeItem, setActiveItem }) => {
  return (
    <div
      className={`styling-wrap__type-item ${
        JSON.stringify(activeItem) == JSON.stringify(item) ? "active" : ""
      }`}
      onClick={() => {
        setActiveItem(item);
      }}
    >
      {item.name}
    </div>
  );
};
